import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/member/newmember_limited_time@2x.png'
import _imports_1 from '@/assets/image/icon/member/newmember_crown@2x.png'
import _imports_2 from '@/assets/image/icon/member/newmember_coin_ja.png'
import _imports_3 from '@/assets/image/icon/member/home_vip_banner_crown@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-5ef13121"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "abs limited_time"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "abs newmember_crown"
}
const _hoisted_3 = { class: "newMemberInfo abs flex-cen-ter" }
const _hoisted_4 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "abs newmember_coin"
}
const _hoisted_5 = { class: "numBack flex-cen-ter" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_8 = {
  key: 0,
  class: "symbol"
}
const _hoisted_9 = { class: "numBack flex-cen-ter" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "flex-cen-ter"
}
const _hoisted_12 = {
  key: 0,
  class: "symbol"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "memberBanner flex-cen-ter"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/member/home_vip_banner_back@2x.png",
  alt: "",
  class: "abs backImg"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/member/home_vip_banner_star@2x.png",
  alt: "",
  class: "abs backStar"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "abs backCrown"
}, null, -1))

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { useRtfix, isJA, isKO, isEN, isJE } from '@/store'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { Site } from '@/common/const'
import { getCurrentMonetaryUnit, getActivePriceByStation } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const user = computed(() => store.getters.user)
const onlyOpenSpecail = computed(() => store.getters.onlyOpenSpecail)
const loginText = store.getters.isSub ? '查看会员' : '开通会员'
const visible = ref(user?.value?.membership?.templateLevel > 0)
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

console.log(visible, onlyOpenSpecail, 'visible222');

const memberClick = () => {
  confirmLoginWithNoCurShop(() => {
    if (user?.value?.membership?.templateLevel < 1) {
      router.push(useRtfix('VipLevel'))
    }
  })
}

const currentMonetaryUnit = getCurrentMonetaryUnit()

return (_ctx: any,_cache: any) => {
  return (!visible.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(newMemberActivity) && !_unref(onlyOpenSpecail))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({ 'memberBanner': true, 'flex-cen-ter': true, 'newMemberBanner': _unref(isJA)(), 'isKoBannerImage': _unref(isKO)(), 'isEnBannerImage': _unref(isEN)() })
            }, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                : _createCommentVNode("", true),
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                (_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  (_unref(isJE)())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(t)("首次加入会员，尊享首月")) + " ", 1),
                        _createElementVNode("div", _hoisted_5, [
                          _createTextVNode(_toDisplayString(_unref(isEN)() && _unref(newMemberActivity).hasSpecialTrialDiscount ? _unref(currentMonetaryUnit) : '') + " ", 1),
                          (_unref(newMemberActivity).hasSpecialTrialDiscount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(newMemberActivity).specialPrice), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice) + " ", 1),
                                (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "％"))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        _createTextVNode(" " + _toDisplayString(!(_unref(isEN)() && _unref(newMemberActivity).hasSpecialTrialDiscount) ? (_unref(newMemberActivity).hasSpecialTrialDiscount ?
              _unref(currentMonetaryUnit) : 'OFF') : ''), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(t)("首次加入会员，尊享首月")) + " ", 1),
                        _createElementVNode("div", _hoisted_9, [
                          (_unref(newMemberActivity).hasSpecialTrialDiscount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(newMemberActivity).specialPrice) + " 원!", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _createTextVNode(_toDisplayString(_unref(newMemberActivity).specialPrice), 1),
                                (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "％"))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        (!_unref(newMemberActivity).hasSpecialTrialDiscount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString('OFF')))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _createElementVNode("div", {
                  class: "payForMember newMemberBtn flex-cen-ter cursor-pt",
                  onClick: memberClick,
                  style: _normalizeStyle({ width: _unref(isEN)() ? '351px' : '' })
                }, _toDisplayString(_unref(t)('立即入会')), 5)
              ])
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(_unref(t)("中国買付を強力にサポートする機能を多数利用可能")) + "！ ", 1),
              _createElementVNode("div", {
                class: "payForMember flex-cen-ter cursor-pt",
                onClick: memberClick
              }, _toDisplayString(_unref(t)(_unref(loginText))), 1),
              _hoisted_15,
              _hoisted_16,
              _hoisted_17
            ]))
      ], 64))
    : _createCommentVNode("", true)
}
}

})